import svc from "@/services/index.svc";

export default {
  state: {
    indices: [],
    comparators: [],
    dataTypes: []
  },
  getters: {
    getIndices: state => {
      const x = [...state.indices];
      return x
        .filter(p => !p.isSuppressed)
        .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
    },
    getSuppressedIndices: state => {
      const x = [...state.indices];
      return x
        .filter(p => p.isSuppressed)
        .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
    },
    getComparators: state => state.comparators,
    getDataTypes: state => [{ text: "" }].concat(state.dataTypes)
  },
  mutations: {
    setComparators(state, payload) {
      state.comparators = payload;
    },
    setDataTypes(state, payload) {
      state.dataTypes = payload;
    },
    setIndices(state, payload) {
      state.indices = payload;
    },
    updateIndexDetails(state, payload) {
      let idx = state.indices.findIndex(p => p.name === payload.name);
      if (idx > -1) {
        state.indices.splice(idx, 1, payload);
      } else {
        state.indices.push(payload);
      }
    }
  },
  actions: {
    refreshComparatorsAsync({ commit }) {
      svc
        .getComparators()
        .then(res => {
          commit("setComparators", res.values);
        })
        .catch(err => console.error(err));
    },
    refreshDataTypesAsync({ commit }) {
      svc
        .getDataTypes()
        .then(res => {
          commit("setDataTypes", res.values);
        })
        .catch(err => console.error(err));
    },
    refreshIndicesAsync({ commit }) {
      svc
        .getIndices()
        .then(res => {
          console.log(res);
          commit("setIndices", res.values);
        })
        .catch(err => console.error(err));
    },
    updateIndexDetailsAsync({ commit }, payload) {
      svc
        .saveIndexDetails(payload)
        .then(res => {
          commit("updateIndexDetails", res.value);
        })
        .catch(err => console.error(err));
    }
  }
};
